import { useEffect } from "react";
import Lottie from "lottie-react";
import lottieAnim from "../../../assets/lottie/autosuggestion.json";

export default function MakroFunktion({
  pauseAll,
  lottieRef,
  htmlRef,
}: {
  pauseAll: (lottieRef: any) => void;
  lottieRef: any;
  htmlRef: any;
}) {
  useEffect(() => {
    const playVideoWhenInView = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          pauseAll(lottieRef);
          lottieRef.current?.play();
        } else {
          lottieRef.current?.pause();
        }
      });
    };

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    const observer = new IntersectionObserver(playVideoWhenInView, options);

    if (htmlRef.current) {
      observer.observe(htmlRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [htmlRef, lottieRef, pauseAll]);

  return (
    <div className="mx-auto grid grid-cols-1 border-b md:border-none md:grid-cols-2 md:py-32 mx-auto items-center gap-4 items-start container pb-[15px] md:pb-[40px] mb-8 md:pb-0 ">
      <div className="mb-6 md:mb-0 md:container order-2 md:order-1">
        <h2 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          DoctioAssist og autosuggestion
        </h2>
        <p>
          Doctio Pro gør det hurtigt at indsætte fraser fra din Doctio database
          ved hjælp af en ‘hotkey’ funktion med autosuggestion - vi kalder det
          DoctioAssist. DoctioAssist kan nemt og tidsbesparende indsætte fraser
          vha. et defineret tastaturklik, og hjælper dig samtidig med at foreslå
          den frase du forsøger at indsætte. Dette sparer klinikeren tid, i
          modsætning til de tradtionelle indbyggede frasesystemer, hvor der skal
          åbnes nye vinduer, foretage flere tastatur- og museklik og laves
          eksterne søgninger for at finde den rigtige frase. Med DoctioAssist
          giver det mening at indsætte selv små delfraser; f.eks: dele af den
          objektive undersøgelse, behandlingsplaner, procedurer, ordinationer,
          beskrivelser, parakliniske undersøgelser, vanlig information og
          samtykke.
        </p>
        <a href="/signup" className="text-doctio-green font-bold">
          Opret dig som Doctio Pro bruger
        </a>
      </div>

      <div className="flex order-1 md:container md:order-2 justify-center">
        <div ref={htmlRef} className="player w-full">
          <Lottie
            animationData={lottieAnim}
            autoplay={false}
            loop={true}
            lottieRef={lottieRef}
            className="player"
          />
        </div>
      </div>
    </div>
  );
}
